module.exports = __webpack_public_path__ + "static/media/mpds_maintenance-illustration.b9737fbc.svg";